export default {
  path: '/workbench',
  title: '工作台',
  icon: 'flask',
  hideSub: true,
  children: (pre => [
    {
      title: '总中控台',
      icon: 'dot-circle-o',
      path: `/index`
    },
    // {
    //   title: '部门动态',
    //   icon: 'dot-circle-o',
    //   path: `${pre}/status`
    // },
    {
      title: '任务列表',
      icon: 'dot-circle-o',
      path: `${pre}/task`
    },
    {
      title: '我的任务',
      icon: 'dot-circle-o',
      path: `${pre}/task/my`
    },
    // {
    //   title: '邀请转发',
    //   icon: 'dot-circle-o',
    //   path: `${pre}/invitation`
    // }
  ])('/workbench')
}
